import React from 'react';
import {
    CreateConservationActionActivityFeedItemDescription
} from "./CreateConservationActionActivityFeedItemDescription";

export const CreatePermitActivityFeedItemDescription = props => {
    const {CustomEventData, Event} = props;

    return <p>
        {Event?.Activity?.User?.name} added a {CustomEventData?.permitType} from {CustomEventData?.permitOrg} permit
        on {CustomEventData?.title}.
    </p>;
};


